//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


export default {
  name: 'StatsFooter',
  data: () => ({
  }),
  computed: {
      playerplayed() {
        return this.$store.getters.getPlayerPlayedCount
      },
      questionCount() {
        return this.$store.getters.getQuestion1Count + this.$store.getters.getQuestion2Count + this.$store.getters.getQuestion3Count
      },
      legendsCount() {
        return this.$store.getters.getLegendsCount
      },
      krampenCount() {
        return this.$store.getters.getKrampenCount
      }
  },
  watch: {
    playerplayed(newValue/*, oldData*/) {
      console.log(newValue)
    },
    questionCount: function() {
      console.log(this.$store.getters.getQuestion1Count + this.$store.getters.getQuestion2Count + this.$store.getters.getQuestion3Count)
    },
    legendsCount: function() {
      console.log(this.$store.getters.getLegendsCount)
    },
    krampenCount: function() {
      console.log(this.$store.getters.getKrampenCount)
    }
  },
  methods: {
    reset: function() {
        this.$store.dispatch("resetStats");
    },
    allplayed: function() {
        console.log(this.$store.getters.getPlayerPlayed)
    },
    questionCountDetails: function() {
        console.log(this.$store.getters.getQuestion1Count + this.$store.getters.getQuestion2Count + this.$store.getters.getQuestion3Count)
        console.log(this.$store.getters.getQuestion1Count)
        console.log(this.$store.getters.getQuestion2Count)
        console.log(this.$store.getters.getQuestion3Count)
    },
    legends: function() {
      console.log(this.$store.getters.getLegends)
    }
    ,
    krampen: function() {
      console.log(this.$store.getters.getKrampen)
    }
  }
}
